import { defineComponent, h, inject } from 'vue';
import { LegacyForm, LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { ItemFormProps } from '@/ui/components/inspectionReport/types';
import ItemFactory from '@/ui/components/inspectionReport/factories/ItemFactory';
import { isLowQualityImagesFromReportPageKey } from '@/ui/injectionKeys';

interface ItemProps extends ItemFormProps {
  itemFactory: ItemFactory;
}

const Item = defineComponent<ItemProps>({
  name: 'Item',
  props: ['item', 'itemFactory'],
  setup(props) {
    const isLowQualityImages = inject(isLowQualityImagesFromReportPageKey, false);

    return function render() {
      return props.itemFactory.getItem(props.item, isLowQualityImages);
    };
  },
});

export function makeItem(item: LegacyItem | LegacyForm) {
  return h(Item, {
    props: {
      item,
      itemFactory: useInspectionReport().getInspectionItemFactory(),
    },
  });
}
